<template lang="pug">
	.side-nav-outer-toolbar
		header-toolbar.layout-header(
			:menu-toggle-enabled="true"
			:toggle-menu-func="toggleMenu"
			:title="title")
		dx-drawer.layout-body(
			position="before"
			template="menu"
			:opened.sync="menuOpened"
			:opened-state-mode="drawerOptions.menuMode"
			:reveal-mode="drawerOptions.menuRevealMode"
			:min-size="drawerOptions.minMenuSize"
			:shading="drawerOptions.shaderEnabled"
			:close-on-outside-click="drawerOptions.closeOnOutsideClick")
			dx-scroll-view.with-footer(:useNative="false" direction="both")
				.scroll-content
					slot
				slot(name="footer")
			side-nav-menu(
				v-if="$auth.authenticated()"
				slot="menu"
				slot-scope="_"
				class="dx-swatch-additional"
				:compact-mode="!menuOpened"
				:selected-item="$route.path"
				:items="menuItems"
				@click="handleSideBarClick")
		.app-version.font-tiny Version {{$auth.getVersion()}}
</template>

<script>
import DxDrawer from 'devextreme-vue/drawer';
import DxScrollView from 'devextreme-vue/scroll-view';

import menuItems from '../app-navigation';
import HeaderToolbar from '../components/header-toolbar.vue';
import SideNavMenu from '../components/side-nav-menu.vue';

export default {
	components: {
		DxDrawer,
		DxScrollView,
		HeaderToolbar,
		SideNavMenu
	},
	props: {
		title: String,
		isXSmall: Boolean,
		isLarge: Boolean
	},
	data() {
		return {
			menuOpened: this.isLarge,
			menuTemporaryOpened: false,
			menuItems: menuItems
		};
	},
	computed: {
		drawerOptions() {
			const shaderEnabled = !this.isLarge;
			return {
				menuMode: this.isLarge ? 'shrink' : 'overlap',
				menuRevealMode: this.isXSmall ? 'slide' : 'expand',
				minMenuSize: this.isXSmall ? 0 : 60,
				menuOpened: this.isLarge,
				closeOnOutsideClick: shaderEnabled,
				shaderEnabled
			};
		},
		headerMenuTogglerEnabled() {
			return this.isXSmall;
		}
	},
	watch: {
		isLarge() {
			if (!this.menuTemporaryOpened) {
				this.menuOpened = this.isLarge;
			}
		},
		$route() {
			if (this.menuTemporaryOpened || !this.isLarge) {
				this.menuOpened = false;
				this.menuTemporaryOpened = false;
			}
		}
	},
	methods: {
		toggleMenu(e) {
			const pointerEvent = e.event;
			pointerEvent.stopPropagation();
			if (this.menuOpened) {
				this.menuTemporaryOpened = false;
			}
			this.menuOpened = !this.menuOpened;
		},
		handleSideBarClick() {
			if (this.menuOpened === false) this.menuTemporaryOpened = true;
			this.menuOpened = true;
		}
	}
};
</script>

<style lang="scss">
	.side-nav-outer-toolbar {
		flex-direction: column;
		display: flex;
		height: 100%;
		width: 100%;

		> .app-version {
			position: fixed;
			right: 10px;
			bottom: 6px;
			color: rgba(0,0,0,0.4);
			pointer-events: none;
		}
	}

	.layout-header {
		z-index: 1501;
	}

	.layout-body {
		flex: 1;
		min-height: 0;
	}

	.content {
		flex-grow: 1;
	}
</style>
